import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/core/auth.service';
import { CommonService } from 'src/app/service/common.service';
import { RestService } from 'src/app/service/rest.service';

@Component({
  selector: 'app-whatsapp-login',
  templateUrl: './whatsapp-login.component.html',
  styleUrl: './whatsapp-login.component.scss',
  standalone:true,
  imports:[
    CommonModule
  ]
})
export class WhatsappLoginComponent implements OnInit {
  accesCode: any;
  status: any;

  constructor(
    private route: ActivatedRoute,
    private restService: RestService,
    private router: Router,
    private authService: AuthService,

  ) {

    this.route.params.subscribe((routeParams: any) => {
      this.accesCode = routeParams?.accessCode ?? null;
    });
  }
  ngOnInit(): void {
    if (this.accesCode) {
      this.status = 1;
      this.verifyWhatsapp();
    }
  }


  verifyWhatsapp() {
    // this.loader.show();
    let params = {
      "accessCode": this.accesCode ?? null
    }
    this.restService.postUATAuthData(params, 'api/digital/core/Customer/ValidateWhatsAppLoginRequest').subscribe((data) => {

      if (data.rcode === 200) {
        this.status = 2;
        this.authService.b2cAttemptAuth(data?.rObj?.token);
        setTimeout(() => {
          // const newTab = window.open('/landing');
          this.router.navigate(['/landing'])
          // if (newTab) {
          //   window.close();
          // }
        }, 2000);
      }
      else {
        this.status = 3;
        // this.commonService.handleRcodeError(data)
      }
    },
      (error) => {
        this.status = 3;
        // this.commonService.handleStatusError(error);
      }
    );
  }



}
